// extracted by mini-css-extract-plugin
export default {"appWrapper":"Layout_appWrapper__EW6iu","mainContent":"Layout_mainContent__aa1Gf"};